import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, isValid, reset, touch, focus } from 'redux-form';

import * as targetActions from 'modules/target';
import * as currentStatusActions from 'modules/currentStatus';

import * as validFunc from 'libs/validation';
import { userEmailAsyncValidate } from 'libs/validation';
import * as adminLib from 'libs/adminLib';
import * as commonVar from 'libs/commonVar';

import { TargetEdit } from 'components';

const reduxFormName = 'targetEdit';

class CtTargetEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: true,
      errorMessage: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    const { invalid, editResetNow, editSaveNow, setEditInvalid, setDisableSave } = this.props;
    const { formStore } = nextProps;

    if (invalid !== nextProps.invalid && typeof setEditInvalid === 'function') {
      setEditInvalid(nextProps.invalid);
    }

    if (nextProps.editResetNow && nextProps.editResetNow !== editResetNow) {
      this.resetUser();
    }

    if (nextProps.editSaveNow && nextProps.editSaveNow !== editSaveNow) {
      if (nextProps.invalid) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(true);
        }
        this.markFieldValidate(reduxFormName);
      } else {
        this.saveTarget();
      }
    }

    if (formStore && formStore.fields) {
      const errorType = ['syncErrors', 'syncWarnings', 'asyncErrors', 'asyncWarnings'];

      let anyError = false;
      for (const field in formStore.fields) {
        if (
          formStore.fields.hasOwnProperty(field) &&
          formStore.fields[field].touched &&
          formStore.fields[field].visited &&
          formStore.registeredFields[field] &&
          formStore.registeredFields[field].count > 0
        ) {
          for (let i = 0, l = errorType.length; i < l; i++) {
            if (formStore[errorType[i]] && formStore[errorType[i]][field]) {
              anyError = true;
              if (typeof setDisableSave === 'function') {
                setDisableSave(true);
              }
              break;
            }
          }
        }
        if (anyError) {
          break;
        }
      }

      if (!anyError) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(false);
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { formStore } = this.props;
    const { errorMessage } = this.state;

    // 에러 메시지가 있는 상태에서 입력값 변경 시 에러 메시지 초기화
    if ((formStore && formStore.values) !== (prevProps.formStore && prevProps.formStore.values) && errorMessage) {
      this.setState({
        errorMessage: ''
      })
    }
  }

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  saveTarget = async () => {
    const { formUserEditIsValid, addMode, invalid, setEditOnProgress } = this.props;

    if (typeof setEditOnProgress === 'function') {
      setEditOnProgress(true);
    }
    this.setState({ onProgress: true });

    if (!invalid) {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const { isAuth, formStore, targetInfo, TargetActions, handleOnToggleEditModal } = this.props;

      const params = {};
      if (formStore && formStore.values && formStore.registeredFields) {
        for (const field in formStore.registeredFields) {
          if (formStore.registeredFields.hasOwnProperty(field)) {
            if (formStore.registeredFields[field].count > 0) {
              if (typeof formStore.values[field] !== 'undefined' && formStore.values[field] !== targetInfo[field]) {
                params[field] = formStore.values[field];
              }
            }
          }
        }
      }

      if (targetInfo.serviceNo) {
        params.serviceNo = targetInfo.serviceNo;
      }

      let preparedParams = false;
      if (Object.keys(params).length > 0) {
        if (!!!targetInfo.targetNo && addMode && isAuth === 2) {
          preparedParams = true;
        } else if (targetInfo.targetNo) {
          params.targetNo = targetInfo.targetNo;
          preparedParams = true;
        } else {
          //
        }
      }

      if (preparedParams) {
        //
        try {
          let respObj = '';
          if (addMode) {
            respObj = await TargetActions.postTarget(params);
          } else {
            respObj = await TargetActions.putTarget(params);
          }

          if (respObj && respObj.data && respObj.data.error && respObj.data.error[0]) {
            // 에러 메시지 있을 시
            this.setState({
              errorMessage: respObj.data.error[0]
            })
          } else {
            // 모달 창 닫음
            handleOnToggleEditModal();
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        // 업데이트 할 것이 없음
      }
      // if (typeof handleOnToggleEditModal === 'function') {
      //   handleOnToggleEditModal();
      // }
    } else {
      // invalid
      const { formStore } = this.props;
      window.markFieldValidate(formStore, reduxFormName);
    }

    if (typeof handleOnToggleEditModal !== 'function' && typeof this.handleOnOpenEditModal === 'function') {
      this.handleOnOpenEditModal();
    }
  };

  //
  handleOnOpenEditModal = () => {
    const { setEditOnProgress } = this.props;

    if (typeof setEditOnProgress === 'function') {
      setEditOnProgress(false);
    }
    this.setState({ onProgress: false });
  };

  render() {
    const { onProgress, errorMessage } = this.state;
    const { addMode, isAuth, formStore, invalid, targetInfo, handleOnToggleEditModal } = this.props;
    const { handleOnOpenEditModal, saveTarget, handleUserEmailReSend, handleUserEmailCancel } = this;

    return (
      <TargetEdit
        addMode={addMode}
        isAuth={isAuth}
        onProgress={onProgress}
        formStore={formStore}
        invalid={invalid}
        targetInfo={targetInfo}
        saveTarget={saveTarget}
        errorMessage={errorMessage}
        handleOnOpenEditModal={handleOnOpenEditModal}
        handleOnToggleEditModal={handleOnToggleEditModal}
        handleUserEmailReSend={handleUserEmailReSend}
        handleUserEmailCancel={handleUserEmailCancel}
      />
    );
  }
}

CtTargetEdit.propTypes = {
  targetInfo: PropTypes.object
};
CtTargetEdit.defaultProps = {
  targetInfo: {}
};

const mapStateToProps = (state, props) => {
  const { targetInfo } = props;

  return {
    initialValues: targetInfo,
    formStore: state.form[reduxFormName],
    formUserEditIsValid: isValid(reduxFormName)(state),
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  TargetActions: bindActionCreators(targetActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: reduxFormName,
    asyncValidate: userEmailAsyncValidate,
    asyncBlurFields: ['userEmail'],
    enableReinitialize: true,
    touchOnChange: true
  })(injectIntl(CtTargetEdit))
);



// WEBPACK FOOTER //
// ./src/script/containers/target/CtTargetEdit.js